import { Fragment } from "react/jsx-runtime";
import { ScoreRating } from "~/operations";
import { Grid, TableRow } from "@mui/material";
import {
  ImpactCell,
  PublishedCell,
  RiskFactorsCell,
  TitleCell,
} from "~/components/Cells";
import { GenericTable } from "~/components/GenericTable/GenericTable";
import { ReportsNoItemsSection } from "../../components";
import { useAssetReport } from "../hooks/useAssetReport";
import { ReportsSectionHeading } from "~/pages/reports/components/ReportsSectionHeading";

export function AssetReportAdvisories() {
  const { advisories } = useAssetReport();
  const hasAdvisories = Boolean(advisories?.length);

  return (
    <Fragment>
      <ReportsSectionHeading heading="Advisories" disableUpperPadding />

      <Grid size={12} sx={{ my: 3 }}>
        {!hasAdvisories ? (
          <ReportsNoItemsSection target="advisories" />
        ) : (
          <AssetReportAdvisoriesTable advisories={advisories} />
        )}
      </Grid>
    </Fragment>
  );
}

function AssetReportAdvisoriesTable({
  advisories,
}: {
  advisories: ReturnType<typeof useAssetReport>["advisories"];
}) {
  return (
    <GenericTable
      space={undefined}
      items={0}
      tableName="VULNERABILITY_REPORT_ADVISORIES"
      validSortFields={[]}
      printView
    >
      {advisories?.map((advisory) => {
        return (
          <TableRow key={advisory?.id}>
            <ImpactCell
              impact={advisory?.riskValue || 0}
              rating={advisory?.rating || ScoreRating.Critical}
              isActive
            />
            <TitleCell
              title={advisory?.title || ""}
              tags={advisory?.tags}
              options={{ fontSize: 14 }}
            />
            <RiskFactorsCell riskFactors={advisory?.riskFactors} printView />
            <PublishedCell
              date={advisory?.firstDetectedAt || "Never"}
              formatting="absolute"
            />
          </TableRow>
        );
      })}
    </GenericTable>
  );
}
